import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Brand } from "../models/brand.model";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// console.log(BASE_URL);

export const BrandApi = createApi({
  reducerPath: "BrandApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Brand"],
  endpoints: (builder) => ({
    brands: builder.query<Brand[], any>({
      query: ({ aamarId }) => `/brand/all/${aamarId}`,
      providesTags: ["Brand"],
    }),
    BrandsCount: builder.query<Brand[], any>({
      query: ({ aamarId }) => `/brand/count/${aamarId}`,
      providesTags: ["Brand"],
    }),
    brand: builder.query<Brand, string>({
      query: (_id) => `/brand/${_id}`,
      providesTags: ["Brand"],
    }),
    brandList: builder.query<Brand[], any>({
      query: (aamarId) => `/brand/list/${aamarId}`,
      providesTags: ["Brand"],
    }),
    addBrand: builder.mutation<{}, Brand>({
      query: (Brand) => ({
        url: "/brand",
        method: "POST",
        body: Brand,
      }),
      invalidatesTags: ["Brand"],
    }),
    addImportBrand: builder.mutation<{}, Brand>({
      query: (Brand) => ({
        url: "/brand/import",
        method: "POST",
        body: Brand,
      }),
      invalidatesTags: ["Brand"],
    }),
    updateBrand: builder.mutation<void, Brand>({
      query: ({ _id, ...rest }) => ({
        url: `/brand/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Brand"],
    }),
    deleteBrand: builder.mutation<void, string>({
      query: (id) => ({
        url: `/brand/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Brand"],
    }),
  }),
});

export const {
  useBrandsQuery,
  useBrandListQuery,
  useBrandsCountQuery,
  useBrandQuery,
  useAddBrandMutation,
  useAddImportBrandMutation,
  useUpdateBrandMutation,
  useDeleteBrandMutation,
} = BrandApi;

export default BrandApi;
